import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import dayjs from 'dayjs';
export default defineComponent({
    name: 'expireAt',
    props: {
        expireAt: {
            type: String,
            default: '',
        },
    },
    render() {
        if (!this.expireAt) {
            return <div style="text-wrap: nowrap;line-height:24px"><br /></div>;
        }
        const expireTime = <span>{dayjs(this.expireAt).format('YYYY-MM-DD HH:mm')}</span>;
        const expireDay = Math.ceil((+dayjs(this.expireAt) - Date.now()) / 86400e3);
        const warnExpire = <span style='color:red'>{expireDay}{$t('k_ad9f47e0')}</span>;
        const warnExpired = <span style='color:red'>{$t('k_f1e2574a')}{-expireDay}{$t('k_4e3f19b7')}</span>;
        return (<div style="text-wrap: nowrap;line-height:24px">
      {expireTime}&nbsp;&nbsp;{expireDay < 30 && expireDay >= 0 && warnExpire}{expireDay < 0 && warnExpired}
    </div>);
    },
});
